module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location_sola-ca10949daa5e320bdc0a059d95258092.webp";